module.exports = __webpack_public_path__ + "img/1588057703.25e038fc.jpg";